import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { formatCalendarDate } from '@/lib/dates';
import { HotelTeamPicker, PickerTeam } from './HotelTeamPicker';
import { useRoomBlocks, useUpdateRoomBlock } from './hooks/useRoomBlocks';
import { isUnlinkedBlock, isReleaseSoon } from './roomBlockUtils';

export function UnlinkedRoomBlocks({ eventId, teams }: { eventId: string; teams: PickerTeam[] }) {
  const blocks = useRoomBlocks([eventId]);
  const update = useUpdateRoomBlock(eventId);
  const unlinked = (blocks.data || []).filter(isUnlinkedBlock);
  async function save(id: string, registrationId?: string, notTeam = false) {
    try {
      await update.mutateAsync({ id, registrationId, notTeam });
      toast.success(notTeam ? 'Block marked as not a team.' : 'Block linked to team.');
    } catch (error) { toast.error(error instanceof Error ? error.message : 'Unable to update block'); }
  }
  return <section className="space-y-3">
    <h2 className="text-lg font-semibold">Unlinked room blocks ({unlinked.length})</h2>
    {blocks.isLoading && <p className="text-sm text-muted-foreground">Loading room blocks…</p>}
    {blocks.error && <p role="alert" className="text-sm text-destructive">{blocks.error.message}</p>}
    {!blocks.isLoading && !blocks.error && unlinked.length === 0 && <p className="text-sm text-muted-foreground">No unlinked room blocks.</p>}
    {unlinked.map(block => <div key={block.id} className="border-b py-4 grid gap-4 lg:grid-cols-[1fr_1fr_auto] lg:items-center">
      <div className="min-w-0"><p className="font-medium break-words">{block.group_name || block.block_code}</p>
        <p className="text-sm text-muted-foreground break-words">{block.hotel_name}</p>
        <p className="text-sm break-all">{[block.contact_first_name, block.contact_last_name].filter(Boolean).join(' ')} {block.contact_email}</p>
        {block.contact_phone && <p className="text-sm text-muted-foreground">{block.contact_phone}</p>}</div>
      <div className="text-sm"><p>{block.rooms_reserved} / {block.rooms_held} reserved / held</p>
        <p className={isReleaseSoon(block.release_date) ? 'text-destructive' : 'text-muted-foreground'}>Release: {formatCalendarDate(block.release_date, 'MMM d, yyyy', '—')}</p></div>
      <div className="flex flex-col sm:flex-row gap-2 lg:max-w-md">
        <HotelTeamPicker teams={teams} disabled={update.isPending} onChange={id => save(block.id, id)} />
        <Button variant="outline" className="min-h-11 shrink-0" disabled={update.isPending} onClick={() => save(block.id, undefined, true)}>Not a team</Button>
      </div>
    </div>)}
  </section>;
}